import { MatDialogRef } from '@angular/material/dialog';
import { DialogFullScreenComponentContent } from '@toro/common/shared/models/dialogs/dialog-full-screen';
import {
    Component,
    ElementRef,
    OnInit,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FinanceState } from '@toro/common/shared/state-management/finance/finance.reducer';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { StatusTransfer } from '@toro/common/shared/enum/finance/status-transfer.enum';
import { WithdrawHistory } from '@toro/common/shared/models/finance/withdraw-history.model';
import { FinanceActions } from '@toro/common/shared/state-management/finance/finance.action';

@Component({
    selector: 'app-withdrawal-history',
    templateUrl: './withdrawal-history.component.html',
    styleUrls: ['./withdrawal-history.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class WithdrawalHistoryComponent
    extends DialogFullScreenComponentContent
    implements OnInit
{
    @Input() showCloseButton = true;

    public financeConsolidade$: Observable<FinanceState>;

    public readonly statusTransfer = StatusTransfer;

    public withdrawals: WithdrawHistory[];

    constructor(
        public element: ElementRef,
        private router: Router,
        private dialogReference: MatDialogRef<WithdrawalHistoryComponent>,
        private store: Store<AppState>
    ) {
        super(element);
    }

    public ngOnInit() {
        super.ngOnInit();

        this.store.dispatch({ type: FinanceActions.getWithdrawHistory });
        this.store
            .select(({ finance }) => finance.withdrawHistory)
            .subscribe((withdrawals: WithdrawHistory[]) => {
                this.withdrawals = this.sortingDescendingByScheduleDate(withdrawals);
            });
    }

    /**
     * Fecha o dialogo
     * direciona o cliente para a home logada
     */
    public dispose() {
        this.router.navigate(['/saque']).then(() => {
            super.close(this.dialogReference, null);
        });
    }

    public getWithdrawalTitle(withdrawal: WithdrawHistory): string {
        switch (withdrawal.statusTransfer) {
            case StatusTransfer.Agendada:
                return 'Aguardando janela de transferência';
            case StatusTransfer.Aprovada:
                return 'Aprovado';
            case StatusTransfer.Rejeitada:
                return 'Rejeitado';
            case StatusTransfer.Finalizada:
                return 'Finalizado';
            case StatusTransfer.Integrada:
                return 'Integrado';
            case StatusTransfer.CanceladaPeloCliente:
                return 'Cancelado pelo cliente';
            case StatusTransfer.DevolucaoAprovada:
                return 'Devolução aprovada';
            case StatusTransfer.DevolucaoConcluida:
                return 'Devolução concluída';
            case StatusTransfer.SaqueDevolvido:
                return 'Devolvido';
        }
    }

    private sortingDescendingByScheduleDate(withdrawals: WithdrawHistory[]): WithdrawHistory[] {
        return (withdrawals || []).sort(
            (a, b) =>
                new Date(b.scheduleDate).getTime() -
                new Date(a.scheduleDate).getTime()
        );
    }
}
